import React from "react";
import { Service } from "../../../../dto/interfaces";
import { HospitalIcon } from "lucide-react";

interface ServiceCardParams {
    service: Service;
}

/**
 * A reusable card component to display a single service.
 */
const ServiceCard: React.FC<ServiceCardParams> = ({ service }) => {
    const IconComponent = HospitalIcon;

    const onBookAppointment = () => {
        // Find the booking section element by its ID
        const bookingSection = document.getElementById("book-appointment");

        if (bookingSection) {
            // Use the browser's built-in smooth scroll
            bookingSection.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
            // Fallback if the element isn't found
            console.warn("Booking section with id 'book-appointment' not found.");
        }
    };

    return (
        <div
            onClick={onBookAppointment}
            className="bg-white rounded-[32px] flex flex-col justify-center items-center md:items-start p-6 md:p-8 shadow-sm hover:shadow-lg transition-shadow duration-300 ease-in-out md:min-w-72 min-w-48 cursor-pointer"
        >
            {/* Icon Container */}
            <div className="mb-4">
                <div className="w-14 h-14 bg-blue-50 flex items-center justify-center rounded-2xl">
                    <IconComponent className="w-7 h-7 text-blue-600" />
                </div>
            </div>

            {/* Text Content */}
            <h3 className="text-xl font-bold text-gray-900 mb-2">{service.name}</h3>
            <p className="text-gray-600 text-sm leading-relaxed">{service.description}</p>
        </div>
    );
};

export default ServiceCard;
